import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PlantGroup } from '../../../types';
import { DasRP, Dastrack } from '../../../types/Device';

type PlantManagementPage = {
  selectedGroup: PlantGroup;
  dastracks: Array<Dastrack>;
  dasrps: Array<DasRP>;
};

const initialState: PlantManagementPage = {
  selectedGroup: {
    id: '',
    name: '',
    remark: '',
    projectId: '',
    createdAt: '',
    updatedAt: '',
    isDefault: false,
    sequence: null,
    plantType: 'plant',
  },
  dastracks: [],
  dasrps: [],
};

export const plantManagementPageSlice = createSlice({
  name: 'plantManagement',
  initialState,
  reducers: {
    setSelectedPlantGroup: (
      state,
      action: PayloadAction<PlantManagementPage['selectedGroup']>,
    ) => {
      return {
        ...state,
        selectedGroup: action.payload,
      };
    },
    setDastracks: (
      state,
      action: PayloadAction<PlantManagementPage['dastracks']>,
    ) => {
      return { ...state, dastracks: action.payload };
    },
    setDasRPs: (
      state,
      action: PayloadAction<PlantManagementPage['dasrps']>,
    ) => {
      return { ...state, dasrps: action.payload };
    },
  },
});

export const { setSelectedPlantGroup, setDastracks, setDasRPs } =
  plantManagementPageSlice.actions;
export default plantManagementPageSlice.reducer;
